const l = "_label_1vppn_1", e = {
  label: l
};
export {
  e as default,
  l as label
};
//# sourceMappingURL=index.es681.js.map
